export const validateFrontPlank = (newFrontPlank: Record<string, string | number | boolean>) => {
    const {width, position} = newFrontPlank;
    if (!width) {
        return 'Ширина планки не может быть пустой';
    }
    if (isNaN(+width)) {
        return 'Ширина должно быть числом';
    }
    if (!position) {
        return 'Выберите положение планки';
    }

    return "";
}